import React from "react";
import CountUp from "react-countup";
import { navigate } from "gatsby"
import LazyLoad from "react-lazyload";
import { Container, Row, Col, Button } from "react-bootstrap";

import imgC from "../../assets/image/l3/jpg/events.jpg";

const Content = () => {
  return (
    <>
      {/* <!-- Content Area --> */}
      <div className="content-section pt-12 pb-10 bg-default-6 py-xl-25 ">
        <Container>
          <Row className="align-items-center justify-content-md-center">
            <Col lg="4" md="10">
              <div className="content-text text-center text-lg-left mb-9 mb-lg-0 pr-xl-11">
                <h2 className="title gr-text-5 mb-8">
                  Test ant&iacute;genos para eventos
                </h2>
                <p className="gr-text-8 mb-9">
                Ofrecemos un servicio ambulatorio para certificar como evento seguro cualquier reunión, evento o acontecimiento. 
                
                
                </p>
                <Button className="gr-hover-y" onClick={()=>{navigate("#cta-prev")}}>Solicita informaci&oacute;n para tu evento</Button>
              </div>
            </Col>
            <Col lg="4" md="6">
              <div className="content-img rounded-8">
                <img className="w-100 rounded-8" src={imgC} alt="" />
              </div> 
            </Col>
            <Col lg="4" md="6">
              <div className="stats-wrapper mt-6 mt-md-0 pl-xl-9">
                <div
                  className="single-stat py-6"
                  data-aos="fade-left"
                  data-aos-duration="1000"
                >
                  <h3 className="title gr-text-5 mb-5">Resultados en <CountUp duration={3} end={10} /> minutos</h3>
                  <p className="gr-text-8 mb-0">
                    Resultados inmediatos y fáciles de interpretar.
                  </p>
                </div>
                <div
                  className="single-stat py-6"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                ><h3 className="title gr-text-5 mb-5">
                <LazyLoad>
                  <span className="counter">
                    Personal cualificado
                    
                  </span>
                </LazyLoad>
              </h3>
              <p className="gr-text-8 mb-0">
                Somos empresa notificadora ante las autoridades pertinentes. 
              </p>
                  
                </div>
                <div
                  className="single-stat py-6"
                  data-aos="fade-left"
                  data-aos-duration="2000"
                >
                  <h3 className="title gr-text-5 mb-5">
                    <LazyLoad>
                      <span className="counter">
                        Servicio todo incluido
                      </span>
                     
                    </LazyLoad>
                  </h3>
                  <p className="gr-text-8 mb-0">
                   Desinfección, retirada de material biológico y hoja de consentimiento. 
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Content;
